import { useCurrentSiteTakeoverV2 } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import React from 'react'

interface Props {
  background: App.SiteTakeoverBackground
  className?: string
  vertical?: App.SiteTakeoverVertical
  placement?: App.SiteTakeoverPlacement
}

function SiteTakeoverBackgroundImage(props: Props) {
  const { className, background, vertical, placement } = props

  const currentTakeover = useCurrentSiteTakeoverV2({ vertical })

  if (!currentTakeover) {
    return null
  }

  const Background = currentTakeover.backgroundElement

  return <Background
    className={className}
    background={background}
    imageId={currentTakeover.imageId}
    placement={placement}
  />
}

export default SiteTakeoverBackgroundImage
